import React, {useRef, useEffect, useContext } from 'react'; 
import cl from './TotalPrice.module.css' 
import { AppContext } from '../../../../providers/appProvider';
import { useTranslation } from 'react-i18next';
import { t } from 'i18next';

function useHorizontalScroll(amount = 120) {
    const { t } = useTranslation();
    const elementRef = useRef();
    const touchStartXRef = useRef(0);
    const touchEndXRef = useRef(0);
  
    useEffect(() => {
      const element = elementRef.current;
      
      const onScroll = (event) => {
        const oEvent = event || window.event;
        const direction = oEvent.detail ? oEvent.detail * -amount : oEvent.wheelDelta;
        const position = element.scrollLeft;
        element.scrollLeft = position + (direction > 0 ? -amount : amount);
        event.preventDefault();
      };
  
      const onTouchStart = (event) => {
        touchStartXRef.current = event.touches[0].clientX;
      };
  
      const onTouchMove = (event) => {
        touchEndXRef.current = event.touches[0].clientX;
      };
  
      const onTouchEnd = () => {
        if (touchStartXRef.current - touchEndXRef.current > 0) {
          // Swiped left
          element.scrollLeft += amount;
        } else if (touchStartXRef.current - touchEndXRef.current < 0) {
          // Swiped right
          element.scrollLeft -= amount;
        }
      };
  
      element.addEventListener('DOMMouseScroll', onScroll);
      element.addEventListener('mousewheel', onScroll);
      element.addEventListener('touchstart', onTouchStart);
      element.addEventListener('touchmove', onTouchMove);
      element.addEventListener('touchend', onTouchEnd);
  
      return () => {
        element.removeEventListener('DOMMouseScroll', onScroll);
        element.removeEventListener('mousewheel', onScroll);
        element.removeEventListener('touchstart', onTouchStart);
        element.removeEventListener('touchmove', onTouchMove);
        element.removeEventListener('touchend', onTouchEnd);
      };
    }, [amount]);
  
    return elementRef;
  }
    
const TotalPrice = ({sum}) => {  
 
    // const scrollRef = useHorizontalScroll(80);   // gamoiyene --> ref={scrollRef}

    const { appState, app } = useContext(AppContext);
    return (
        <div className={ cl.totalBox }  > 

            {app.hasPermission("SUM_WINDOW_SHOW") && 
            <>

            {app.hasPermission("FUND_CLIENT_PRICE_FUND_SHOW") && 
                <div className={cl.financeBox } >
                    <div className={cl.financeDesc }>{t('RequestedAmount')}</div>
                    <div style={{ }}  className={cl.financeValue}> { sum.PriceFund } $</div> 
                </div>
            }

            {app.hasPermission("FUND_CALC_SHOW") && 
                <div className={cl.financeBox } >
                    <div className={cl.financeDesc }>{t('Procent')}</div>
                    <div style={{ }}  className={cl.financeValue}> { sum.FundPercent} $</div> 
                </div>
            }


            {app.hasPermission("BONUS_SHOW") &&
                <div className={cl.financeBox }  >
                    <div className={cl.financeDesc }>{t('Bonus')}</div>
                    <div style={{color:"#009688", background: '#d3e9e6'}} className={cl.financeValue}> { sum.Bonus } $</div> 
                </div> 
             }

          
            {app.hasPermission("CLIENT_DEBT_SHOW") &&

                <div className={cl.financeBox } >
                    <div className={cl.financeDesc }>{t('ClientsDebt')}</div>
                    <div style={{color:"#d80228", background: 'rgb(255 223 216)'}}  className={cl.financeValue}> { sum.ClientDebt} $</div> 
                </div>
            }
 
            {app.hasPermission("COMPANY_DEBT_SHOW") &&
            <div className={cl.financeBox }  >
                <div className={cl.financeDesc }>{t('CompanyDebt')} </div>
                <div style={{color:"#d80228", background: 'rgb(255 223 216)'}} className={cl.financeValue}> { sum.CompanyDebt} $</div> 
            </div>
             }
 
            {app.hasPermission("PWIN_SHOW") &&
            <div className={cl.financeBox }  >
                <div className={cl.financeDesc }>{t('PlannedProfit')} </div>
                <div style={{color:"#009688", background: '#d3e9e6'}} className={cl.financeValue}> { sum.Pwin} $</div> 
            </div>
            }
 
           {app.hasPermission("RWIN_SHOW") &&
                <div className={cl.financeBox }  >
                    <div className={cl.financeDesc }>{t('RealProfit')} </div>
                    <div style={{color:"#009688", background: '#d3e9e6'}} className={cl.financeValue}> { sum.Rwin } $</div> 
                </div> 
            }
            {app.hasPermission("TOTAL_CLIENT_DISCOUNT") && 
                <div className={cl.financeBox } >
                    <div className={cl.financeDesc }>  {t('Discount')} </div>
                    <div style={{ }}  className={cl.financeDesc}> { sum.ClientDiscount } $</div> 
                </div>
            }

            </>
            
         }
       
 
        </div>
    );
};

export default TotalPrice;